'use strict';

import { frmAjaxErrors, checkPw } from './forms.js';
import { getUserTime } from './Times.js';
import { ajaxWrapNew, CommandRegistry, ResponseDispatcher } from './ajaxWrapNew.js';


// šis izpildīsies pie DOMContentLoaded ja būs body[data-page="profile"]
export function loadProfile() {
    window['confirmpassword'] = function($fld) {
        let confirmpassword = $fld.find('.j-password').val();

        if (!confirmpassword || confirmpassword.toString().trim() === '') {
            $fld.find('.j-password').each(function() {
                $( this ).parent().addClass('error');
                $( this ).one('blur.autoerror change.autoerror keyup.autoerror', function() {
                    $( this ).parent().removeClass('error');
                });
            });
            return false;
        }

        return true;
    };

    const profileCommands = {
        profileEmailVerify: (payload) => {
            if (payload.verify == 'verifyProgress') {
                $('.emailStatusText.verifyActive').hide();
                $('.emailStatusText.verifyDone').hide();
                $('.emailStatusText.verifyProgress').show()
                    .attr('data-timeout', payload.timeoutSeconds)
                    .data('timeout', payload.timeoutSeconds);

                if (payload.timeoutSeconds > 0) {
                    setTimeout(function() {
                        $('.emailStatusText.verifyProgress').hide();
                        $('.emailStatusText.verifyActive').show();
                    }, payload.timeoutSeconds * 1000);
                }
            } else if (payload.verify == 'verifyDone') {
                $('.emailStatusText.verifyActive').hide();
                $('.emailStatusText.verifyProgress').hide();
                $('.emailStatusText.verifyDone').show();
            } else if (payload.verify == 'verifyActive') {
                $('.emailStatusText.verifyActive').show();
                $('.emailStatusText.verifyProgress').hide();
                $('.emailStatusText.verifyDone').hide();
            }
        }
    };
    CommandRegistry.registerCommands(profileCommands);

    var prfAction = function(action, el, dialog) {
        if (!action) {
            return false;
        }

        var addData = {};
        var $prnt = $( el ).closest('form');

        switch ( action ) {
            case 'editPassword':
                $( el ).closest('.frm1')
                    .find('[name="current_password"]').val('').end()
                    .find('.j-ifnot-editPassword').hide().end()
                    .find('.j-if-editPassword').removeClass('disabled').show().end()
                    .find('[name="passwordChange"]').val(1);
                return;

            case 'deleteAccount':
                $prnt = $( el ).closest('.confirmpassword');
                break;
            case 'deleteAccountConfirm':
                $prnt = $( el ).closest('.confirmpassword');

                if ($( el ).closest('.dialogBox').find('.j-password').length) {
                    addData.confirmpassword = $( el ).closest('.dialogBox').find('.j-password').val();

                    if (!addData.confirmpassword || addData.confirmpassword.toString().trim() === '') {
                        $( el ).closest('.dialogBox').find('.j-password').each(function() {
                            $( this ).closest('fieldset').addClass('error');
                            $( this ).one('blur.autoerror change.autoerror keyup.autoerror', function() {
                                $( this ).closest('fieldset').removeClass('error');
                            });
                        });
                        return false;
                    }
                }
                break;

            case 'verifyEmail':
                addData.email = $prnt.find('[name="email"]').val();
                break;
        }

        const ajaxData = $.extend({
                ajax: 1,
                action: action,
                time: getUserTime()
            }, addData);

        ajaxWrapNew({
            method: 'POST',
            data: ajaxData,
            success: function(data) {
                ResponseDispatcher.handle(data, action);

                try {
                    if (data.formStatus) {
                        frmAjaxErrors( $prnt, data.formStatus );
                    }
                } catch (e2) {
                    console.log(e2);
                }
            },
            dataType : 'json'
        });

        return true;
    };

    $( 'body' ).on('click.prf', '.frmAct', function( event, data ) {
        if ($( this ).is('a')) {
            event.preventDefault();
        }

        event.stopPropagation();

        if ($( this ).hasClass('no-action') && !(event && event.originalEvent instanceof MouseEvent && event.originalEvent.ctrlKey)) {
            return;
        }

        if(!prfAction( $( this ).data('action'), this, data ? data.dialog : null )) {
            if (data && data.dialog) {
                data.dialog.stopClose = true;
            }
        }
    });

    $( 'body' ).on('click.prf', '.verify-button', function( event, data ) {
        if ($( this ).is('a')) {
            event.preventDefault();
        }

        event.stopPropagation();

        if(!prfAction( $( this ).data('action'), this, data ? data.dialog : null )) {
            if (data && data.dialog) {
                data.dialog.stopClose = true;
            }
        }
    });

    let timeoutSeconds = $('.emailStatusText.verifyProgress').data('timeout');
    if (timeoutSeconds > 0 && $('.emailStatusText.verifyProgress').is(':visible')) {
        setTimeout(function() {
            $('.emailStatusText.verifyProgress').hide();
            $('.emailStatusText.verifyActive').show();
        }, timeoutSeconds * 1000);
    }


    const apiVerifiedPop = document.getElementById('apiVerifiedPop');
    if (apiVerifiedPop) {
        if (apiVerifiedPop.dataset.action == 'apiVerified') {
            $('.frmAct[data-action="deleteAccount"]').trigger('click');
        }
    }
}
